import { config } from '../config';

interface Props {
  latlng: [number, number];
  mapLayer?: string;
  width?: number;
  height?: number;
  zoom?: number;
}

export const staticMap = ({
  latlng: [lat, lng],
  width = 800,
  height = 400,
  zoom = 14.6,
}: Props) => {
  return `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/${markerOverlay(
    [lat, lng],
  )}/${lng},${lat},${zoom},0/${width}x${height}@2x?access_token=${
    config.mapboxToken
  }`;
};

export const markerOverlay = ([lat, lng]: [number, number]) => {
  return `pin-l+5635DF(${lng},${lat})`;
};
